import { useEffect, useState } from 'react'
import { useUserActivity } from '../UserActivityContext'

export const useUserInactivity = (timeoutMs: number) => {
  const { lastActivity } = useUserActivity()
  const [inactive, setInactive] = useState(false)

  useEffect(() => {
    const check = () => {
      const now = Date.now()
      setInactive(now - lastActivity > timeoutMs)
    }

    check()

    const interval = setInterval(check, 60 * 1000) // check every minute
    return () => clearInterval(interval)
  }, [lastActivity, timeoutMs])

  return inactive
}
